module.exports=function(scope){ return `// This sample code demonstrates using onBeforeZoomDismiss to tweak FaceTec exit animations and timing.
// This function must return true to signal to FaceTec that the developer is making an explicit decision to override the default dismiss behavior.
- (bool)onBeforeZoomDismissWithResult:(enum ZoomSessionResult)result {
  // In this example, we do an alpha+scale animation to make the FaceTec Interface disappear.  Developers can change this to suit their application.
  dispatch_async(dispatch_get_main_queue(), ^{
      [UIView animateWithDuration:0.5 delay:0 options:UIViewAnimationOptionCurveEaseOut animations:^{
          [self.sessionVC setAlpha:0];
          [self.sessionVC setTransform:CGAffineTransformScale(self.sessionVC.transform, 0.8, 0.8)];
      } completion:^(BOOL _){
          // Make sure to dismiss the User Session VC when done.
          [self.sessionVC dismissViewControllerAnimated:false completion:nil];
      }];
  });

  return true;
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/ios/37-exit-animations.m.tpl